import Vue from "vue";
import Vuex from "vuex";

import state from './state';
import getters from "./getter";
import actions from './actions';
import mutations from './mutations';
import register from './register/register';
import purchaseOrder from './purchase-order/purchase-order';
import myOrder from './my-order/my-order';
import addressManage from './address-manage/address-manage';
import searchBar from './search-bar/search-bar';
import cart from './cart/cart';
import confirm from './confirm/confirm';
import personalCenter from './personal-center/personal-center';
import createWare from './create-ware/create-ware';
import spellBuy from './spell-buy/spell-buy';
import invoiceManage from './invoice-manage/invoice-manage';
import productLine from './product-line/product-line';
import limitSale from './limit-sale/limit-sale';
import letter from './letter/letter';
import brand from './brand/brand';
import agreement from './agreement'
import agentPurchaseList from './agent-purchase-list/agent-purchase-list'

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules:{
        register,
        purchaseOrder,
        myOrder,
        addressManage,
        searchBar,
        cart,
        confirm,
        personalCenter,
        createWare,
        spellBuy,
        invoiceManage,
        productLine,
        limitSale,
        letter,
        brand,
        agreement,
        agentPurchaseList
    }
});



// WEBPACK FOOTER //
// ./src/store/store.js